module.exports = __webpack_public_path__ + "pedro_markun--751ed7d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/pedro_markun.jpg
// module id = 169
// module chunks = 0